import React from 'react'
import './HorizontalBarChart.css'

const percentageWidth = (data, item) => {
    const max = Math.max(...data.map(d => d.y))
    const value = item.y / max
    return value * 100
}

class AnimatedBar extends React.Component {
    state = {
        width: 1,
    }

    componentDidMount() {
        // eslint-disable-next-line
        requestAnimationFrame(() => this.setState({ width: this.props.width }))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.width !== this.state.width) {
            this.setState({ width: nextProps.width })
        }
    }

    render() {
        return (
            <div
                className="datum-bar"
                style={{ width: `${this.state.width}%` }}
            />
        )
    }
}

const HorizontalBarChart = ({ data }) => (
    <div style={{ flex: 1 }}>
        {data.map(item => (
            <div className="datum" key={`${item.x}${item.y}`}>
                <div className="datum-label">{item.x}</div>
                <div className="flex">
                    <AnimatedBar width={percentageWidth(data, item)} />
                    <div className="datum-value">{item.y}</div>
                </div>
            </div>
        ))}
    </div>
)

export default HorizontalBarChart